import React from 'react';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { GetSlateReportPredictions } from '../../../api/slate-report';

interface SortFilterProps {
  sortBy: GetSlateReportPredictions.SortBy;
  onSortChange: (sortBy: GetSlateReportPredictions.SortBy) => void;
}

const SortFilter: React.FC<SortFilterProps> = ({ sortBy, onSortChange }) => {
  const handleToggleGroupChange = (value: string) => {
    if (
      value &&
      ['date', 'box_office_gross', 'box_office_multiple'].includes(value)
    ) {
      onSortChange(value as GetSlateReportPredictions.SortBy);
    }
  };

  return (
    <ToggleGroup
      type="single"
      value={sortBy}
      onValueChange={handleToggleGroupChange}
      className="tw-rounded-full tw-bg-white tw-shadow-xs tw-border tw-border-gray-200 tw-overflow-hidden tw-p-0 tw-w-fit tw-h-7"
    >
      <ToggleGroupItem
        value="date"
        className="tw-px-2 tw-py-0 tw-text-xs tw-font-medium tw-text-gray-600 hover:tw-bg-gray-50 data-[state=on]:tw-bg-blue-500 data-[state=on]:tw-text-white tw-transition-colors tw-border-r tw-border-gray-200 tw-rounded-none tw-first:tw-rounded-l-full tw-last:tw-rounded-r-full tw-last:tw-border-r-0 tw-h-full tw-min-h-0"
      >
        Date
      </ToggleGroupItem>
      <ToggleGroupItem
        value="box_office_gross"
        className="tw-px-3 tw-py-0 tw-text-xs tw-font-medium tw-text-gray-600 hover:tw-bg-gray-50 data-[state=on]:tw-bg-blue-500 data-[state=on]:tw-text-white tw-transition-colors tw-border-r tw-border-gray-200 tw-rounded-none tw-first:tw-rounded-l-full tw-last:tw-rounded-r-full tw-last:tw-border-r-0 tw-h-full tw-min-h-0"
      >
        WW B.O.
      </ToggleGroupItem>
      <ToggleGroupItem
        value="box_office_multiple"
        className="tw-px-2 tw-py-0 tw-text-xs tw-font-medium tw-text-gray-600 hover:tw-bg-gray-50 data-[state=on]:tw-bg-blue-500 data-[state=on]:tw-text-white tw-transition-colors tw-border-r tw-border-gray-200 tw-rounded-none tw-first:tw-rounded-l-full tw-last:tw-rounded-r-full tw-last:tw-border-r-0 tw-h-full tw-min-h-0"
      >
        B.O.M.
      </ToggleGroupItem>
    </ToggleGroup>
  );
};

export default SortFilter;
